import React, { Component } from 'react';
import { Modal, Button, Alert, Popconfirm, Icon } from 'antd';
import { PushNotification } from 'utils/PushNotification';
import { restartSsoWebApp } from '../../services/CeberusApiService';
import './RestartAccountModal.scss';

type RestartAccountModalProps = {
  visible: boolean;
  onCancel: () => void;
};

type RestartAccountModalState = {
  isRestarting: boolean;
};

class RestartAccountModal extends Component<RestartAccountModalProps, RestartAccountModalState> {
  constructor(props: RestartAccountModalProps) {
    super(props);
    this.state = {
      isRestarting: false,
    };
  }

  handleRestartWebApp = async () => {
    try {
      this.setState({ isRestarting: true });

      await restartSsoWebApp();

      PushNotification.success('🔄 Account restart initiated successfully! This may take a few minutes.');

      this.props.onCancel();

    } catch (httpError) {
      const error: any = httpError;
      const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message || '';

      if (errorMessage.toLowerCase().includes('business hours')) {
        PushNotification.error('⏰ Restart blocked: SSO activation is only allowed outside of business hours. Please try again later.');
      } else {
        PushNotification.httpError(httpError);
      }
    } finally {
      this.setState({ isRestarting: false });
    }
  };

  render() {
    const { visible, onCancel } = this.props;
    const { isRestarting } = this.state;

    return (
      <Modal
        title={<span><Icon type="warning" style={{ color: '#ff4d4f' }} /> Restart Account - Critical Operation</span>}
        visible={visible}
        onCancel={onCancel}
        className="restart-account-modal"
        footer={[
          <Button key="cancel" onClick={onCancel} disabled={isRestarting}>
            Cancel
          </Button>,
          <Popconfirm
            key="confirm"
            title="Are you absolutely sure you want to restart the Account?"
            onConfirm={this.handleRestartWebApp}
            okText="Yes, Restart Now"
            cancelText="No"
            okType="danger"
          >
            <Button type="danger" loading={isRestarting}>
              Confirm Restart
            </Button>
          </Popconfirm>
        ]}
      >
        <Alert
          message="⚠️ Important Warning"
          description="This operation will restart the Account and cause temporary downtime."
          type="warning"
          showIcon
          className="restart-account-modal__alert"
        />

        <div className="restart-account-modal__prerequisites">
          <strong>Before proceeding, please ensure:</strong>
          <ul>
            <li>✅ SSO configuration has been activated (Step 1)</li>
            <li>⏰ You are outside business hours</li>
          </ul>
        </div>

        <Alert
          message="Note"
          description="The API will automatically validate business hours. If you're within business hours, the operation will be blocked."
          type="info"
          showIcon
          className="restart-account-modal__alert"
        />
      </Modal>
    );
  }
}

export default RestartAccountModal;
